"use client";

import { Badge } from "@devhop/ui";

const LABELS: Record<string, string> = {
  draft: "ຮ່າງ",
  submitted: "ສົ່ງແລ້ວ",
  partially_received: "ຮັບບາງສ່ວນ",
  received: "ຮັບຄົບ",
  canceled: "ຍົກເລີກ",
};

export function purchaseOrderStatusLabel(status: string): string {
  return LABELS[status] ?? status;
}

/** ສີຕາມ design ຮ້ານ: draft=neutral, submitted=info (Tech Blue), partial=warning, received=success, canceled=destructive */
function variantFor(status: string) {
  switch (status) {
    case "draft":
      return "secondary" as const;
    case "submitted":
      return "info" as const;
    case "partially_received":
      return "warning" as const;
    case "received":
      return "success" as const;
    case "canceled":
      return "destructive" as const;
    default:
      return "secondary" as const;
  }
}

export function PurchaseOrderStatusBadge({
  status,
  className,
}: {
  status: string;
  className?: string;
}) {
  return (
    <Badge
      variant={variantFor(status)}
      className={className ?? "font-normal"}
    >
      {purchaseOrderStatusLabel(status)}
    </Badge>
  );
}
